import React from "react";
import "../css/acservice.css";
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";

export default function ACService() {
  return (
    <>
    <Topbar/>
      <Header />
      {/* Hero (your original card) */}
      <section className="ac-hero">
        <div className="ac-hero-bg" />

        <div className="ac-hero-card">
          <p className="ac-hero-kicker">RELIABLE SOLUTIONS</p>

          <h1 className="ac-hero-title">
            Expert AC Services for
            <br />
            Ultimate Comfort All Year
            <br />
            Round
          </h1>

          <p className="ac-hero-subtitle">
            Get all kinds of AC service at your doorstep in 30 minutes. Schedule
            your service now!
          </p>

          <a className="ac-hero-cta" href="tel:7237898275">
            7237898275
          </a>
        </div>
      </section>

      {/* === New content section: two-column layout like screenshots === */}
      <section className="ac-article-section">
        <div className="container ac-article-grid">
          <div className="ac-article-text">
            <h2 className="ac-article-heading">Premier AC Solutions in Surat</h2>

            <p>
              <a className="ac-link" href="#">Jay Ambe AC Service</a> is your
              go-to provider for comprehensive air conditioner solutions in
              Surat. With years of experience in the industry, we specialize in
              all types of <a className="ac-link" href="#">AC service</a>,
              ensuring that your indoor environment remains cool and
              comfortable throughout the year.
            </p>

            <p>
              Our offerings include installation, where our skilled technicians
              help you choose and set up the right air conditioning system
              tailored to your needs—be it a split unit or central air system.
              We take pride in delivering precise installation with minimal
              disruption to your home or business.
            </p>

            <p>
              In addition to installation, we excel in repair services. If your
              air conditioner is not cooling effectively or making unusual
              noises, our team can quickly diagnose the issue and provide
              efficient repairs. We understand how important a functioning AC is
              during hot months, which is why we prioritize timely service
              without compromising quality.
            </p>

            <p>
              Regular maintenance is key to extending the lifespan of your
              unit. At Jay Ambe AC Service, we offer customized maintenance
              packages designed to keep your system running smoothly. Our
              routine checks include cleaning filters, inspecting coolant
              levels, and ensuring all components are working optimally.
            </p>

            <p>
              We also provide duct cleaning services to enhance indoor air
              quality by removing dust and allergens from your ductwork. Clean
              ducts improve airflow efficiency while promoting a healthier
              living space.What sets us apart at Jay Ambe AC Service is our commitment to
              customer satisfaction through exceptional service delivery and
              affordable pricing. Our certified technicians are dedicated
              professionals who ensure every job meets stringent standards of
              quality.
            </p>
          </div>

          <div className="ac-article-image-wrap">
            <img
              className="ac-article-image"
              src={require("../assets/ac-article.jpg")}
              alt="AC service"
            />
          </div>
        </div>
      </section>
          <Herolast  />
      <Footer  />
    </>
  );
}
